import { render, staticRenderFns } from "./_base-switch.vue?vue&type=template&id=37d8f65a"
import script from "./_base-switch.vue?vue&type=script&lang=js"
export * from "./_base-switch.vue?vue&type=script&lang=js"
import style0 from "./_base-switch.vue?vue&type=style&index=0&id=37d8f65a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports